import * as React from "react";
// import styled from "styled-components";
import classNames from "classnames";

import { SvgSprite } from "./SvgSprite";

type AnchorProps = React.DetailedHTMLProps<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  HTMLAnchorElement
>;

interface IconLinkProps extends AnchorProps {
  icon: string;
}

export const IconLink: React.FC<IconLinkProps> = ({
  icon,
  children,
  ...rest
}) => {
  return (
    <a
      css={`
        display: inline-flex;
      `}
      {...rest}
    >
      <span
        aria-hidden
        css={`
          flex: 0 0 auto;
        `}
        className="mr-2"
      >
        <SvgSprite
          id={icon}
          width={16}
          height={16}
          css={`
            vertical-align: sub;
          `}
        />
      </span>
      <span
        css={`
          flex: 1 1 auto;
        `}
      >
        {children}
      </span>
    </a>
  );
};

type ButtonProps = React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;

interface IconButtonProps extends ButtonProps {
  icon: string;
  noVerticalAlign?: boolean;
}

export const IconLinkBtn: React.FC<IconButtonProps> = ({
  icon,
  className,
  children,
  noVerticalAlign,
  ...rest
}) => {
  return (
    <button
      css={`
        display: inline-flex;
        border: 0;
      `}
      className={classNames("btn btn-link p-0 text-left", className)}
      {...rest}
    >
      <span
        aria-hidden
        css={`
          flex: 0 0 auto;
        `}
        className={children ? "mr-2" : undefined}
      >
        <SvgSprite
          id={icon}
          width={16}
          height={16}
          css={noVerticalAlign ? undefined : `vertical-align: sub;`}
        />
      </span>
      <span
        css={`
          flex: 1 1 auto;
        `}
      >
        {children}
      </span>
    </button>
  );
};
